import './three-setup'; // must stay first: global three.js colour settings
import './styles.css';
import { boot } from './app';
import { initPwaUi, registerServiceWorker } from './pwa';

boot();
initPwaUi();
registerServiceWorker();
